import { render, staticRenderFns } from "./RegistryClassificationFields.vue?vue&type=template&id=0c777e07"
import script from "./RegistryClassificationFields.vue?vue&type=script&lang=js"
export * from "./RegistryClassificationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c777e07')) {
      api.createRecord('0c777e07', component.options)
    } else {
      api.reload('0c777e07', component.options)
    }
    module.hot.accept("./RegistryClassificationFields.vue?vue&type=template&id=0c777e07", function () {
      api.rerender('0c777e07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/RegistryClassificationFields.vue"
export default component.exports